import {put, takeLatest, call} from 'redux-saga/effects';
import * as reportService from "../../../services/reportService";
import {
    GET_PRODUCTSALES_REPORT,
    GET_PRODUCTSALES_REPORT_SUCCESS,
    GET_PRODUCTSALES_REPORT_ERROR,
}
    from "../../actions/report"

function* getProductSalesReportSaga(action) {
    try {
       const data  = yield call(reportService.GetProductSalesReport,action.payload)
       yield put({
        type: GET_PRODUCTSALES_REPORT_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_PRODUCTSALES_REPORT_ERROR,error: error.data
        })
    }
}


export function* getProductSalesReportSagaWatcher() {
    yield takeLatest(GET_PRODUCTSALES_REPORT, getProductSalesReportSaga)
}